import { gql } from "apollo-boost";

/*Posts Queries*/

export const GET_ATTENDANCE_LIST = gql`
  query {
    allAttendance {
      edges {
        node {
          id
          attendanceId
          athleteId
          workoutId
          effectiveDate
          missed
          comments
          updateDate
          updateSource
        }
      }
    }
  }
`;

export const ADD_ATTENDANCE = gql`
  mutation MutateAttendance(
    $attendanceId: Int!
    $athleteId: Int!
    $workoutId: Int!
    $effectiveDate: Date!
    $missed: Int!
    $comments: String!
    $updateSource: String!
  ) {
    attendanceAdd(
      attendanceData: {
        attendanceId: $attendanceId
        workoutId: $workoutId
        athleteId: $athleteId
        effectiveDate: $effectiveDate
        missed: $missed
        comments: $comments
        updateSource: $updateSource
      }
    ) {
      node {
        attendanceId
        athleteId
        workoutId
        effectiveDate
        missed
        comments
        updateSource
      }
    }
  }
`;

export const GET_ACTIVITY = gql`
  query {
    allActivity {
      edges {
        node {
          activityId
          activityName
          activityDescription
          activityCategory
          USCode
          EUCode
          CANCode
          HRMinPct
          HRMaxPct
          DURATIONMin
          DURATIONMax
          WORKRest
          SWIMDurationMin
          SWIMDurationMax
          activityColor
          activityType
          VO2maxPct
          activityNameTmp
        }
      }
    }
  }
`;

export const GET_RECORDS_LIST = gql`
  query recordsList(
    $leagueSeqno: Int
    $clubId: Int
    $teamId: Int
    $ageFrom: Int
    $ageTo: Int
    $facilityType: String!
  ) {
    recordsList(
      leagueSeqno: $leagueSeqno
      clubId: $clubId
      teamId: $teamId
      ageFrom: $ageFrom
      ageTo: $ageTo
      facilityType: $facilityType
    ) {
      mFirstName
      mResultTime
      mResultDate
      mClubName
      setId
      distance
      stroke
      fFirstName
      fResultTime
      fResultDate
      fClubName
    }
  }
`;

export const GET_STANDARDS_LIST = gql`
  query standardsList(
    $gender: String
    $facilityType: String
    $classification: String
  ) {
    standardsList(
      gender: $gender
      facilityType: $facilityType
      classification: $classification
    ) {
      gender
      facilityType
      classification
      count
      ranksTable
    }
  }
`;

export const GET_NEW_TOKEN = gql`
  mutation getNewAccessToken {
    getNewAccessToken {
      newAccessToken
    }
  }
`;

/*User Queries */

/*Post Mutations*/

/*User Mutations*/

export const UPLOAD_FILES = gql`
  mutation uploadFile($file: Upload!) {
    uploadFiles(file: $file) {
      success
    }
  }
`;
